export default __webpack_public_path__ + "static/media/session-icon.1c2bccdf.svg";